import { Injectable } from '@angular/core';
import { DateUtility } from 'src/app/common/utility/date/date';
import { StorageService } from '../storage/storage.service';

/**
 * Manage Token storage and claims requests
 */
@Injectable({
  providedIn: 'root'
})
export class TokenService {

  public get valid(): boolean {
    return this.hasAccessToken && !this.expired;
  }

  public get expired(): boolean {
    return !this.hasExpirationDate || DateUtility.expired(this.expirationDate ?? 0);
  }

  public get hasClaims(): boolean {
    return !!this.claims
  }

  public get hasExpirationDate(): boolean {
    return !!this.hasClaims ? !!this.claims.exp : false;
  }

  public get expirationDate(): number | null {
    return this.claims?.exp ?? null
  }

  public get hasAccessToken(): boolean {
    return !!this.AccessToken;
  }

  public get RefreshToken(): string | null {
    return StorageService.RefreshToken
  }

  public get IdToken(): string | null {
    return StorageService.IdToken
  }

  public get AccessToken(): string | null {
    return StorageService.AccessToken
  }

  public get claims(): any {
    return StorageService.Claims
  }

  public get EmailAddress(): string | null {
    return this.claims?.email
  }

  public get AuthenticationId(): string | null {
    return this.claims?.sub
  }

  public getClaimValue(key: string): string | null {
    return !!this.claims ? this.claims[key] : null
  }

  public anyClaims(type: string[], value: string | null = null): boolean {
    if (!type || !this.hasClaims) {
      return false;
    }

    type = Array.isArray(type) ? type : [type];
    const claims = Object.keys(this.claims)
    return claims.some(key => type.some(claimType => claimType === key) && (!value || this.claims[key] === value))
  }

  public hasClaim(claim: string): boolean {
    return this.anyClaims([claim]);
  }

  constructor() { }
}
